import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { MainPage, MainPageGroupDetailParams, MainPageGroupListParams, MainPageShuffle } from './mainPage.types';

export const getMainPageGroupList = (client: AxiosInstance) => async (params: MainPageGroupListParams) => {
  return (await client.get<PaginatedApiResponse<MainPage[]>>(API_ROUTES.GET_MAIN_PAGE_GROUP, { params })).data;
};

export const getMainPageGroupDetails = (client: AxiosInstance) => async (params: MainPageGroupDetailParams) => {
  return (await client.get<ApiResponse<MainPage[]>>(API_ROUTES.GET_MAIN_PAGE_GROUP, { params })).data;
};

export const getMainPageShuffle = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<MainPageShuffle[]>>(API_ROUTES.MAIN_PAGE_SHUFFLE)).data;
};

export const mainPageQueries = {
  all: () => ['main-page-group'],
  list: (params: MainPageGroupListParams) =>
    queryFactoryOptions<PaginatedApiResponse<MainPage[]>>({
      queryKey: [...mainPageQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getMainPageGroupList(client)(params),
    }),
  detail: (params: MainPageGroupDetailParams) =>
    queryFactoryOptions<ApiResponse<MainPage[]>>({
      queryKey: [...mainPageQueries.all(), 'detail', params],
      queryFn: (client: AxiosInstance) => () => getMainPageGroupDetails(client)(params),
    }),
  shuffle: () =>
    queryFactoryOptions<ApiResponse<MainPageShuffle[]>>({
      queryKey: [...mainPageQueries.all(), 'shuffle'],
      queryFn: (client: AxiosInstance) => () => getMainPageShuffle(client)(),
    }),
};
